import { useTranslation } from "react-i18next";
import ToolGrid from "../components/ToolGrid";

export default function PdfTools() {
  const { t } = useTranslation();
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-12" data-testid="pdf-tools-page">
      <span className="eyebrow">02 — {t("nav_pdf")}</span>
      <h1 className="hero-h2 text-3xl sm:text-5xl mt-2">{t("tools_title")}</h1>
      <p className="text-zinc-500 mt-2">{t("tools_subtitle")}</p>
      <div className="mt-10">
        <ToolGrid />
      </div>
    </div>
  );
}
